import Svg, { SvgProps, Path } from 'react-native-svg';

const SwapIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M22.99 3.99a1 1 0 0 0-.697 1.717L24.586 8H11a1 1 0 1 0 0 2h13.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l3.912-3.912a1 1 0 0 0 .004-1.588 1 1 0 0 0-.006-.004l-3.91-3.91a1 1 0 0 0-.717-.303zM3 8a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-1.02 7.99a1 1 0 0 0-.687.303l-3.912 3.912a1 1 0 0 0 .002 1.592l3.91 3.91a1 1 0 1 0 1.414-1.414L4.414 22H18a1 1 0 1 0 0-2H4.414l2.293-2.293a1 1 0 0 0-.727-1.717zM22 20a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1z" />
  </Svg>
);

export default SwapIcon;
